import { Component, Input } from '@angular/core';


/**
 * Renders an in-app link to a customer ("First Last") when one is present,
 * otherwise a muted fallback label ("Not linked" / "None"), for list-report
 * cells whose customer is optional. Customer ids are a positive integer or
 * null, so a truthy check suffices. The host is display:contents (see the
 * css) so it adds no element box.
 */
@Component({
  selector: 'app-nullable-customer-link',
  templateUrl: './nullable-customer-link.component.html',
  styleUrls: ['./nullable-customer-link.component.css'],
})
export class NullableCustomerLinkComponent {
  @Input() customerId: number | null;
  @Input() firstName: string;
  @Input() lastName: string;

  // Optional sub-route beneath the customer ('payments'). A path with child
  // routes ('reservations/bookings') is split below: the router encodes each
  // array entry as one segment, so passing it whole yields "%2F".
  @Input() section: string | null = null;


  // Shown (with fallbackClass) when there is no customer.
  @Input() fallbackText = 'None';
  @Input() fallbackClass = 'text-muted';

  get routerLink(): string[] {
    const id = (this.customerId === null || this.customerId === undefined)
      ? ''
      : this.customerId.toString();
    return this.section
      ? ['/customers', id, ...this.section.split('/')]
      : ['/customers', id];
  }
}
